import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from '@components/home/home.component';
import { CallbackComponent } from '@components/auth/callback/callback.component';
import { DictamenListadoComponent } from '@components/administracion/dictamen-listado/dictamen-listado.component';
import { DictamenMedicoComponent } from '@components/administracion/dictamen-medico/dictamen-medico.component';
import { CasoDictamenComponent } from '@components/administracion/caso-dictamen/caso-dictamen.component';
import { TrazabilidadComponent } from '@components/expedientes-trazabilidad/trazabilidad.component';
import { ReportesAnaliticasComponent } from '@components/reportes-analiticas/reportes-analiticas.component';
import { CierreAdministrativoComponent } from '@components/administracion/cierre-administrativo/cierre-administrativo.component';
import { SolicitudSaludIrrecuperableComponent } from '@components/solicitud-salud-irrecuperable/solicitud-salud-irrecuperable.component';
import { PresentacionInicialComponent } from '@components/presentacion-inicial/presentacion-inicial.component';
import { ApelacionDocumentosComponent } from '@components/apelacion-documentos/apelacion-documentos.component';


const routes: Routes = [
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  { path: 'home', redirectTo: 'inicio', pathMatch: 'full' },
  { path: 'inicio', component: HomeComponent },
  { path: 'login/callback', component: CallbackComponent },

  {
    path: 'administracion',
    children: [
      { path: 'dictamen', component: DictamenListadoComponent },
      { path: 'dictamen-medico', component: DictamenMedicoComponent },
      { path: 'dictamen-medico/:id', component: CasoDictamenComponent },
      { path: 'cierre-administrativo/:id', component: CierreAdministrativoComponent },
    ]
  },
  { path: 'administracion/reportes', component: ReportesAnaliticasComponent },
  { path: 'expedientes/:id/trazabilidad', component: TrazabilidadComponent },
  { path: 'documentos/presentacion-inicial', component: PresentacionInicialComponent },
  { path: 'documentos/apelacion', component: ApelacionDocumentosComponent },
  { path: 'solicitud-salud-irrecuperable', component: SolicitudSaludIrrecuperableComponent },

  { path: '**', redirectTo: 'inicio' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
